import { render, staticRenderFns } from "./modalHandledErrors.vue?vue&type=template&id=0d641a3c&scoped=true&"
import script from "./modalHandledErrors.vue?vue&type=script&lang=js&"
export * from "./modalHandledErrors.vue?vue&type=script&lang=js&"
import style0 from "./modalHandledErrors.vue?vue&type=style&index=0&id=0d641a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d641a3c",
  null
  
)

export default component.exports